/* eslint-disable arrow-parens */
/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpEvent,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse,
} from '@angular/common/http';
import {
    take,
    catchError,
    Observable,
    throwError,
    switchMap,
    filter,
    timeout,
} from 'rxjs';
import { SurveyForceStoreService } from './survey-force-store.service';

@Injectable()
export class AuthenInterceptor implements HttpInterceptor {
    private isRefreshing = false;

    constructor(private _authenService: SurveyForceStoreService) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        let authRequest = req;
        const accessToken = this._authenService.getToken();
        if (accessToken) {
            authRequest = this._handleCloneRequest(req, accessToken);
        }
        return next.handle(authRequest).pipe(
            catchError((error) => {
                if (
                    error instanceof HttpErrorResponse &&
                    error.status === 401
                ) {
                    return this._handle401Error(authRequest, next);
                }
                return throwError(error);
            })
        );
    }

    private _handle401Error = (
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> => {
        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this._authenService.getTokenFromParents();
        }
        return this._authenService.watchToken().pipe(
            filter((token) => token !== ''),
            take(1),
            timeout({
                each: 15000,
                with: () => throwError(() => new Error('Connection Timeout')),
            }),
            switchMap((token: string) => {
                this.isRefreshing = false;
                return next.handle(this._handleCloneRequest(request, token));
            }),
            catchError((err) => {
                this.isRefreshing = false;
                return throwError(err);
            })
        );
    };

    private _handleCloneRequest = (
        request: HttpRequest<any>,
        token: string
    ) => {
        return request.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`,
            },
        });
    };
}
